/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import {
  getCommonContractLawCaseRejectionCategorySelectOptions,
  getRentalContractCaseRejectionCategorySelectOptions
} from "../contract/contractLawFormHelperService";
import {
  getGeneralCivilLawCaseRejectionCategorySelectOptions
} from "../generalCivilLaw/generalCivilLawFormHelperService";
import { LitigationUnion } from "../../../../types/LitigationUnion";

export const getLitigationCaseRejectionCategorySelectOptions = (product: LitigationUnion) => {
  if (product.productCategory === "contractLaw") {
    return getCommonContractLawCaseRejectionCategorySelectOptions();
  }

  if (product.productClassName === "rentalContract") {
    return getRentalContractCaseRejectionCategorySelectOptions();
  }

  if (product.productClassName === "generalCivilLaw") {
    return getGeneralCivilLawCaseRejectionCategorySelectOptions();
  }

  return [{ value: "none" }, { value: "individual" }];
};
